

import {React, useEffect, useState}  from 'react';
import {  FaShoppingCart, FaStoreAltSlash } from "react-icons/fa";
import { Link } from 'react-router-dom';
import  './Customcss/home.css';
import axios from 'axios';
import CustomerChart from './Charts/CustomerChart';
import ProductChart from './Charts/ProductChart';
import MonthlyChart from './Charts/MonthlyChart';
import WeeklyChart from './Charts/WeeklyChart';
import { Row } from 'react-bootstrap';
import BallTriangle from 'react-loading-icons/dist/esm/components/ball-triangle';
import { useStateContext } from './Context/ContextProvider';
import CustomerTable from './Dashboard Items/CustomerTable';
function Dashboard() {
  const [Stores ,setStores]=useState([]);
  const [topCustomers ,settopCustomers]=useState([]);
  const [monthwise ,setmonthwise]=useState([]);
  const [productsdata ,setproductsdata]=useState([]);
  const [weeklysale ,setweeklysale]=useState([]);
  const [dailyExpense,setDailyExpense]=useState('0');
  const [monthlyExpense,setMonthlyExpense]=useState('0');
  const [dailyWasooli,setDailyWasooli]=useState('0');
  const [monthlyWasooli,setMonthlyWasooli]=useState('0');
  const [dailyUdhar,setDailyUdhar]=useState('0');
  const [monthlyUdhar,setMonthlyUdhar]=useState('0');
  const [Loading,setLoading]=useState(true);
  const {type}=useStateContext();
 const [inactiveCustomers,setInactiveCustomers]=useState([]);
 const [defaulters,setDefaulters]=useState([]);
  

useEffect(()=>{
  axios.get('/sanctum/csrf-cookie').then(response => {
axios.get('/api/home').then(res=>{

  setStores(res.data.stores);
setmonthwise(res.data.monthwise);
settopCustomers(res.data.customerwise);
setproductsdata(res.data.productsdata);
setweeklysale(res.data.weeklysale);
setMonthlyExpense(res.data.monthlyTotalExpense);
setDailyExpense(res.data.dailyExpense);
setDailyWasooli(res.data.dailyTotalWasooli);
setMonthlyWasooli(res.data.monthlyTotalWasooli);
setDailyUdhar(res.data.dailyUdhar);
setMonthlyUdhar(res.data.monthlyUdhar);
setInactiveCustomers(res.data.inactiveCustomers);
setDefaulters(res.data.defaulters);
setLoading(false);
});
  });
},[]);

useEffect(()=>{
       
},[]);

if(type==='Salesman'){

return(
<div className='categories row animated fadeInDown' >

{
Stores.length===0?<center>Please Wait....</center>:
Stores && Stores.map((item,index)=>(
 <div className='boxes col-md-4  animated fadeInDown' key={item.id}>
 <Link to={`/productdetail/${item.id}`}  style={{textDecoration:'none'}}>
  <center>
<FaStoreAltSlash style={{fontSize:'45px'}}/></center>
<hr/>
<p style={{color:'red'}}>{(item.name).slice(0,12)}</p>
 

</Link></div>
))

}


</div>

)

}
  
  
return(

<>



<div  className="fadeInDown animated" style={{height:'auto'}}>
  
<Row className='g-1' style={{margin:'4px'}}>
     {Stores.map(store=>(
     
<div className='col-md shadow' key={store.id}>
<Link to={`/saleentry/${store.id}`} key={store.id} style={{textDecoration:'none',color:'red',textAlign:'center'}}>
  
  {store.name}

 <br/>
  <FaShoppingCart/>
  </Link>
  </div>
  ))} 

  </Row> 
  {Loading?  <div style={{height:'100vh',width:'100vw'}}> <div style={{position: 'fixed',height:'100vh',
  width:'100vh',  transform: 'translate(-50%, -50%)',
  backgroundColor: 'rba(255,255,255,5.8)',top:'50%',left:'50%',textAlign:'center', justifyContent: 'center',alignItems:'center'}}><BallTriangle  style={{marginTop:'45%'}}  stroke='red'  /> </div></div>
  
  :
 
<div className='mx-4' >
 <Row className='g-3 gap-2 mt-0'
 >
  <div className='col-md ' style={{backgroundColor:'green',color:'white',padding:'10px',borderRadius:'5px',opacity:'0.7'}}>
   <div style={{display:'flex',justifyContent:'space-between'}}>


 <div className='urdu-text'>
  <h3>
آج کی وصولی    


  </h3>
</div>

  <div style={{fontSize:20}}>
  {dailyWasooli}
  
  </div>    

 </div><hr></hr>
  <div  style={{display:'flex',justifyContent:'space-between'}}>


<div className='urdu-text'>
  <h3>
ماہانہ وصولی

  </h3>
  
  </div> 
  <div style={{fontSize:20}}>
  {monthlyWasooli}
  
  </div>    

 </div>
 </div>
  
   <div className='col-md ' style={{backgroundColor:'purple',color:'white',padding:'10px',borderRadius:'5px',opacity:'0.8'}}>
   <div style={{display:'flex',justifyContent:'space-between'}}>


 <div className='urdu-text'>
  <h3>
آج کا ادھار

  </h3>
</div>

  <div style={{fontSize:20}}>
{dailyUdhar}
  
  </div>    

 </div><hr></hr>
  <div  style={{display:'flex',justifyContent:'space-between'}}>


<div className='urdu-text'>
  <h3>
ماہانہ ادھار

  </h3>
  
  </div> 
  <div style={{fontSize:20}}>
  {monthlyUdhar}
  
  </div>    

 </div>
 </div>
 
   <div className='col-md ' style={{backgroundColor:'red',color:'white',padding:'10px',borderRadius:'5px',opacity:'0.8'}}>
   
    <div  style={{display:'flex',justifyContent:'space-between'}}>


<div className='urdu-text'>
  <h3>
آج کا خرچہ

  </h3>
  
  </div> 
  <div style={{fontSize:20}}>
  {dailyExpense}
  
  </div>    

 </div><hr></hr>
   <div style={{display:'flex',justifyContent:'space-between'}}>


 <div className='urdu-text'>
  <h3>
ماہانہ اخراجات

  </h3>
</div>

  <div style={{fontSize:20}}>
 {monthlyExpense} 
  
  </div>    

 </div>
 
 </div>
 
  
  
  </Row> 

 <Row 
 className='g-2 '>

<div className='col-md-6'>
<CustomerTable customers={inactiveCustomers} type={1} heading='وہ صارفین جنہوں نے 90 دنوں سے آرڈر نہیں کیا۔
'/>
</div>

<div  className='col-md-6'>
<CustomerTable customers={defaulters} type={2} heading='تاخیر سے ادائیگی کرنے والے گاہک (30 دن سے زیادہ)'/>
</div>



 </Row>

{type!=='Salesman'?<Row className='g-2 mt-4'>
<div className='col-md'>
 
  <WeeklyChart datas={weeklysale}></WeeklyChart>
  </div>
  <div className='col-md'>
 <CustomerChart datas={topCustomers}></CustomerChart>

  </div></Row>:''
  }
  {type!=='Salesman'?
  <Row className='g-2'>
  <div className='col-md'>
  <MonthlyChart data={monthwise}></MonthlyChart>

  </div>
 
  <div className='col-md'>
  <ProductChart data={productsdata}></ProductChart>

  </div>
  </Row>:''
  }
</div>



}
</div>

</>

     
)
};

export default Dashboard;

